module.exports = __webpack_public_path__ + "static/media/a .47fcf96d.svg";